function PrivacyPolicy() {
  return (
    <div className="container py-5 px-3">
      <div className="row">
        <div className="col-lg-10 mx-auto">
          <h1 className="fw-bold mb-4">Privacy Policy</h1>
          <p className="text-muted">Effective Date: [01/01/2024]</p>

          <p>
            Investify ("we", "our", or "us") respects your privacy and is
            committed to protecting your personal information. This Privacy
            Policy explains how we collect, use, and safeguard your information
            when you use the Investify platform.
          </p>

          <h4 className="mt-4">1. Information We Collect</h4>
          <p>We may collect the following types of information:</p>

          <ul>
            <li>Full name</li>
            <li>Email address</li>
            <li>Phone number</li>
            <li>Date of birth</li>
            <li>Identification documents for verification</li>
            <li>Bank or payment details for transactions</li>
          </ul>

          <h4 className="mt-4">2. Usage Information</h4>
          <p>
            We may automatically collect certain information when you use the
            platform, including device information, IP address, app activity,
            transaction history, and investment activity.
          </p>

          <h4 className="mt-4">3. How We Use Your Information</h4>
          <ul>
            <li>Create and manage your account</li>
            <li>Process investment transactions</li>
            <li>Verify your identity</li>
            <li>Prevent fraud and improve security</li>
            <li>Improve the platform and user experience</li>
            <li>Comply with legal and regulatory obligations</li>
          </ul>

          <h4 className="mt-4">4. Data Security</h4>
          <p>
            We implement reasonable security measures to protect your
            information. However, no digital platform can guarantee complete
            security.
          </p>

          <h4 className="mt-4">5. Sharing of Information</h4>
          <p>
            We do not sell your personal information. We may share data with:
          </p>

          <ul>
            <li>Payment processors</li>
            <li>Real estate investment partners</li>
            <li>Service providers that help operate the platform</li>
            <li>Regulatory authorities when required by law</li>
          </ul>

          <h4 className="mt-4">6. Data Retention</h4>
          <p>
            We retain your information only as long as necessary to provide our
            services and meet legal obligations.
          </p>

          <h4 className="mt-4">7. Your Rights</h4>
          <p>You may request to:</p>

          <ul>
            <li>Access your personal data</li>
            <li>Update incorrect information</li>
            <li>Delete your account</li>
          </ul>

          <h4 className="mt-4">8. Changes to This Policy</h4>
          <p>
            We may update this Privacy Policy periodically. Any updates will be
            posted on this page.
          </p>

          <h4 className="mt-4">9. Contact Us</h4>
          <p>If you have questions about this Privacy Policy, contact us at:</p>

          <p>
            <strong>Email:</strong> contact@codecamp.ng <br />
            <strong>Company:</strong> CodeCamp Technologies Ltd <br />
            <strong>Location:</strong> Lagos, Nigeria
          </p>
        </div>
      </div>
    </div>
  );
}

export default PrivacyPolicy;
